import { dataEdit } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEdit = /*#__PURE__*/createIcon(dataEdit)
export default IconEdit
